// extracted by mini-css-extract-plugin
export default {"loader":"SATCustomSpinner__loader__w436K","circularloader":"SATCustomSpinner__circularloader__Ft33E","loaderpath":"SATCustomSpinner__loaderpath__bQRUl"};